import { Table } from 'semantic-ui-react';
import { serverToLocalTime } from '../../../../utils/dateTimeUtils';
import { minToHour, msToHour } from '../utils';

function LogTable({
    duration,
    clicks,
    keystrokes,
    start,
    end,
    warn,
    error,
    inactivityDurationMs,
    middleDuration,
    longDuration,
}) {
    return (
        <Table fixed>
            <Table.Body>
                <Table.Row warning={warn == true} error={error == true}>
                    <Table.Cell className="redFont">{minToHour(duration)}</Table.Cell>
                    <Table.Cell>{minToHour(middleDuration)}</Table.Cell>
                    <Table.Cell>{minToHour(longDuration)}</Table.Cell>
                    <Table.Cell>{clicks}</Table.Cell>
                    <Table.Cell>{keystrokes}</Table.Cell>
                    <Table.Cell>{serverToLocalTime(start)}</Table.Cell>
                    <Table.Cell>{serverToLocalTime(end)}</Table.Cell>
                    <Table.Cell className="yellowFont">
                        {msToHour(end - start - (inactivityDurationMs || 0))}
                    </Table.Cell>
                </Table.Row>
            </Table.Body>
        </Table>
    );
}

export default LogTable;
